/**
 * Extracts API context from various error types for better error tracking
 */
export const extractApiContext = (error: unknown) => {
  if (!error || typeof error !== 'object') {
    return undefined;
  }

  const err = error as any;

  // GraphQL errors from graphql-request
  if (err.response) {
    return {
      endpoint: err.request?.url || 'graphql',
      method: 'POST',
      statusCode: err.response?.status,
      responseBody: JSON.stringify(err.response?.errors || err.response),
    };
  }

  // Axios/Fetch errors
  if (err.config?.url) {
    return {
      endpoint: err.config.url,
      method: err.config.method?.toUpperCase(),
      statusCode: err.response?.status,
      responseBody: err.response?.data
        ? JSON.stringify(err.response.data)
        : undefined,
    };
  }

  // Generic fetch errors
  if (err.status || err.statusCode) {
    return {
      endpoint: err.url || 'unknown',
      method: err.method,
      statusCode: err.status || err.statusCode,
    };
  }

  return undefined;
};
